'use client'
import React from 'react'
import { Box, Typography } from '@mui/material';
export interface NoItemsMessageProps {
    textToShow?: string;
    fontSize?:string
}
const NoItemsMessage: React.FC<NoItemsMessageProps> = ({ textToShow = 'No products available',fontSize='1rem' }) => {
    return (
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 8px 15px 8px' }}>
            <Typography sx={{ color: '#000', fontWeight: '800',fontSize:`${fontSize}` }}>{textToShow}</Typography>
        </Box>
    )
}
export default NoItemsMessage